import {
  cloneColumnOptions,
  cloneDefaultColumnVisibilityModel,
  cloneDefaultSortDirection,
  cloneDefaultSortKey,
  type CloneSortDirection,
  type CloneSortKey,
  type PipelineCloneStatus,
  cloneSortOptions,
  cloneStatusOptions,
} from '@/features/pipelines/pages/pipelinesPageCloneConfig';
import { CloneTableToolbar } from '@/features/shared/components/cloneTable/CloneTableToolbar';
import type { CloneDateQuickFilter } from '@/features/shared/hooks/useCloneDateWindow';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { Dayjs } from 'dayjs';
import type { ReactElement } from 'react';

type PipelinesCloneToolbarProps = {
  onDebouncedCloneSearchChange: (value: string) => void;
  columnVisibilityModel: GridColumnVisibilityModel;
  onColumnVisibilityModelChange: (nextModel: GridColumnVisibilityModel) => void;
  sortKey: CloneSortKey;
  sortDirection: CloneSortDirection;
  onSortChange: (sortKey: CloneSortKey, sortDirection: CloneSortDirection) => void;
  filterStatuses: PipelineCloneStatus[];
  onFilterStatusesChange: (next: PipelineCloneStatus[]) => void;
  filterTags: string[];
  onFilterTagsChange: (next: string[]) => void;
  dateQuickFilter: CloneDateQuickFilter;
  onDateQuickFilterChange: (next: CloneDateQuickFilter) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onFromDateChange: (next: Dayjs | null) => void;
  onToDateChange: (next: Dayjs | null) => void;
  availableTags: string[];
};

export const PipelinesCloneToolbar = (props: PipelinesCloneToolbarProps): ReactElement => (
  <CloneTableToolbar<CloneSortKey, PipelineCloneStatus>
    title="Pipelines"
    searchAriaLabel="Search pipelines, tags"
    defaultColumnVisibilityModel={cloneDefaultColumnVisibilityModel}
    columnOptions={cloneColumnOptions}
    defaultSortKey={cloneDefaultSortKey}
    defaultSortDirection={cloneDefaultSortDirection}
    sortOptions={cloneSortOptions}
    statusOptions={cloneStatusOptions}
    {...props}
  />
);

export type { CloneDateQuickFilter };
